(ns renolit-roofing-service.layout.debouncer
  (:import (goog.async Debouncer)))

(def ^:const default-debounce-interval
  350)

(defn debouncer
  "Uses official construct from Google Closure library to
  debounce f with specified interval."
  [f interval]
  (let [debouncer (Debouncer. f interval)]
    (fn [& args]
      (.apply
       (.-fire debouncer)
       debouncer
       (to-array args)))))
